/**
 * Freeze2Icon — sanitized from `assets/newSvg/freeze2.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function Freeze2Icon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M12,2 C17.5228,2 22,6.47715 22,12 C22,17.5228 17.5228,22 12,22 C6.47715,22 2,17.5228 2,12 C2,6.47715 6.47715,2 12,2 Z M10,8 C9.48716857,8 9.06449347,8.38604429 9.0067278,8.88337975 L9,9 L9,15 C9,15.5523 9.44772,16 10,16 C10.51285,16 10.9355092,15.613973 10.9932725,15.1166239 L11,15 L11,9 C11,8.44772 10.5523,8 10,8 Z M14,8 C13.4477,8 13,8.44772 13,9 L13,15 C13,15.5523 13.4477,16 14,16 C14.5523,16 15,15.5523 15,15 L15,9 C15,8.44772 14.5523,8 14,8 Z"
        fill={color}
      />
    </Svg>
  );
}

export default Freeze2Icon;
